if( document.querySelector('.our-clients') ) {
    jQuery('.our-clients').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        autoplay: true,
        rows: 0,
        infinite: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 639,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });
}